import MyGoogleMap from 'javascripts/modules/google-map';

class LocationMap {

	constructor(){
		this._init();
	}

	_init(){
		const args = {
			// streetViewControl: false,
			// panControl:        false,
			// scrollwheel:       false,
			// cluster:           false
		};

		this.components = document.querySelectorAll(`[data-trigger^="location-map"]`);
		if(this.components.length == 1){
			const map = new MyGoogleMap('location-map1', args);
			const map2 = new MyGoogleMap('location-map', args);
		}else if(this.components.length > 1){
			for (const component of this.components) {
				const mapid = component.getAttribute('data-trigger');
				const map = new MyGoogleMap(mapid, args);
			}
		}
	}

}

export const locationMap = new LocationMap();